
import React from 'react';

const ProcessSection = (props) => {

    return (
        <section className="faqs_section section_space pt-0">
            <div className="container">
                
                <div className='row'>
                    <div className="col-lg-12 text-center">
                        <span class="sub_heading">Process</span>
                        <br/>
                        <br/>
                        <div class="heading_block">
                            <h2 class="heading_text heading_top">How We Work</h2>
                        </div>
                    </div>
                    
                    <div className='col-lg-12'>
                        <ul className='process_ul'>
                            <li>
                                <div className='process_div' style={{backgroundColor: '#FFF3F7'}}>
                                    <span className='process_span' style={{color:'#FFCFDF'}}>01</span>
                                    <h3 className='process_h3'>Audit & Strategy</h3>
                                    <h4 className='process_timeline'>Week 0-2</h4>
                                    <p className='process_p'>Entity gap analysis, AEO visibility baseline, technical fixes, analytics alignment (GA4, GSC, CRM).</p>
                                </div>
                            </li>
                            <li className='mrg_top'>
                                <div className='process_div' style={{backgroundColor: '#FFFCE7'}}>
                                    <span className='process_span' style={{color:'#FBDE01'}}>02</span>
                                    <h3 className='process_h3'>Map & Models</h3>
                                    <h4 className='process_timeline'>Week 2-4</h4>
                                    <p className='process_p'>Topic graph, keyword intent models, page-type taxonomy (integrations, comparisons, use-cases), schema plan.</p>
                                </div>
                            </li>
                            <li>
                                <div className='process_div' style={{backgroundColor: '#ECF9FF'}}>
                                    <span className='process_span' style={{color:'#C7E9F9'}}>03</span>
                                    <h3 className='process_h3'>Build & Ship</h3>
                                    <h4 className='process_timeline'>Week 4-8</h4>
                                    <p className='process_p'>Programmatic templates, priority briefs, internal link architecture, scalable schema, first PR placements.</p>
                                </div>
                            </li>
                            <li className='mrg_top' style={{marginRight: '0'}}>
                                <div className='process_div' style={{backgroundColor: '#F5FFED'}}>
                                    <span className='process_span' style={{color:'#CFF3AF'}}>04</span>
                                    <h3 className='process_h3'>Optimize & Scale</h3>
                                    <h4 className='process_timeline'>Week 8-12</h4>
                                    <p className='process_p'>CRO on pricing/demo pages, link velocity, AEO/GEO coverage expansion, dashboards for trials/demos/MRR.</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    )
};
export default ProcessSection;
